import MiiaFwConfig from '@/configs/config'
import { useRequest } from '@/api/request'
import { GlobalError } from '@/utils/globalError/GlobalError'
import type { ErrorCode } from '@/utils/globalError/entities/valueObjects/types'
import type { QueryParam, QueryResponse } from '@/types/api/operation/disaster/disasterApi'
import { ERROR_CODES } from '@/constants/error/errorCode'

export const useDisasterApi = () => {
  const { request } = useRequest()

  /** 災害情報APIへリクエストする */
  const requestDisasterApi = <T, U>(func: string, arg: T) => {
    return request<T, U>(MiiaFwConfig.config.apiGwEndpointOperation, '/disasters', func, arg)
  }

  /**
   * 災害情報API queryを実行する
   * @param param リクエストパラメータ
   * @returns レスポンス
   */
  const query = async (param: QueryParam) => {
    const res = await requestDisasterApi<QueryParam, QueryResponse>('query', param)
    if ('error' in res) {
      throw new GlobalError(
        [ERROR_CODES._811010_API_EXECUTION_FAILED, res.error.errorCode as ErrorCode],
        { message: res.error.errorMessage }
      )
    }
    return res.result
  }

  return {
    query
  }
}
